import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { Store } from '@ngrx/store';
import * as fromInvoice from '../../core/reducers/invoice.reducer';
import * as actionInvoice from '../../core/actions/invoice.actions';
import { delay } from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-compta',
  templateUrl: './compta.component.html',
  styleUrls: ['./compta.component.scss']
})
export class ComptaComponent implements OnInit {

  navLinks: any[] = [];

  baseNavLinks = [
  	{ 
  		label: 'Factures' ,
  		path: 'sortie',
      canBeDeleted: false
  	},
    { 
      label: 'Notes de crédit' ,
      path: 'entree',
      canBeDeleted: false
    },
  ]; 
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private authService: AuthService, private store: Store<any>) { 
  }

  ngOnInit() {
        this.store.select(fromInvoice.selectOpenInvoices).pipe(delay(500)).subscribe(state => {
          
            this.navLinks = this.baseNavLinks;

            this.navLinks = this.navLinks.concat(state.map(e => {
                return {
                    'label': e.number,
                    'path': 'view/' + e.id,
                    'id': e.id,
                    canBeDeleted: true
                };
            }));        
        });

    }

    deleteTab(idx) {
        this.store.dispatch(new actionInvoice.CloseTabAction(idx));
    }
}
